
import { defineComponent } from 'vue'

export default defineComponent({ name: 'Home' })

/**
 *  Remove Shader effect.
 *  const canvasEl = ref<HTMLCanvasElement>()
 *
 *         let shadertoyInstance: ShadertoyTransform
 *
 *         onMounted(() => {
 *             shadertoyInstance = new ShadertoyTransform({
 *                 canvas: canvasEl.value!,
 *                 contextAttributes: {},
 *                 devicePixelRatio: window.devicePixelRatio * 0.8,
 *                 precision: 'lowp',
 *                 fs: fragmentShaderSource,
 *                 vs: vertexShaderSource,
 *             })
 *
 *             shadertoyInstance.componentDidMount()
 *         })
 *
 *         onUnmounted(() => {
 *             shadertoyInstance.componentWillUnmount()
 *         })
 */
